var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.07 13.76V7.52C46.07 7.52 45.62 10.13 42.02 10.13C38.42 10.13 37.97 7.52 37.97 7.52V13.76H46.06H46.07Z",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.88 13.76V7.52C29.88 7.52 29.82 10.14 26.22 10.14C24.33 10.33 23.19 8.77 21.79 7.52V13.76",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.97 46.05V37.96H46.07V46.05H37.97Z",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.15 37.96H60.39C58.64 38.71 57.58 40.5 57.77 42.39C57.77 45.99 60.39 46.05 60.39 46.05H54.15V37.96Z",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79 54.15V60.39C21.79 60.39 21.85 57.77 25.45 57.77C27.34 57.58 29.14 58.64 29.88 60.39V54.15H21.85V59.16C21.85 61.39 20.04 63.2 17.8 63.21C15.57 63.21 13.76 61.4 13.75 59.16V54.15H8.74C6.51 54.15 4.7 52.34 4.69 50.1C4.69 47.87 7.5 46.05 8.74 46.05L9.17 45.94C10.92 45.19 10.43 44.29 10.24 42.4C10.24 38.8 9.93 38.08 9.93 38.08L13.74 37.95V38.01H5.55C3.32 38.01 1.51 36.2 1.5 33.96C1.5 31.73 3.31 29.92 5.55 29.91H13.76V21.76H7.52C7.52 21.76 10.14 21.82 10.14 25.42C10.33 27.31 9.27 29.11 7.52 29.85H13.76V21.82H8.75C6.52 21.82 4.71 20.01 4.7 17.78C4.7 15.55 6.51 13.74 8.75 13.73H13.76V8.72C13.76 6.49 15.57 4.68 17.81 4.67C20.04 4.67 21.85 6.48 21.86 8.72V13.73H29.95V5.54C29.95 3.31 31.76 1.5 34 1.5C36.23 1.5 38.04 3.31 38.04 5.54V13.75H46.08V8.74C46.08 6.51 47.89 4.7 50.13 4.69C52.36 4.69 54.17 6.5 54.18 8.74V13.75H59.19C61.42 13.75 63.23 15.56 63.24 17.8C63.24 20.03 61.43 21.84 59.19 21.84H54.18V21.78H60.42C60.42 21.78 57.81 22.23 57.81 25.83C57.81 29.43 60.42 29.88 60.42 29.88H54.18V29.94H62.39C64.62 29.94 66.43 31.75 66.44 33.99C66.44 36.22 64.63 38.03 62.39 38.04H54.18V46.07H59.19C61.42 46.07 63.23 47.88 63.24 50.12C63.24 52.35 61.43 54.16 59.19 54.17H54.18V59.18C54.18 61.41 52.37 63.22 50.13 63.23C47.9 63.23 46.09 61.42 46.08 59.18V54.17H38.05V62.38C38.05 64.61 36.24 66.42 34.01 66.43C31.78 66.43 29.97 64.62 29.96 62.38V54.17",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.97 54.15V60.39C37.97 60.39 38.03 57.77 41.63 57.77C43.52 57.58 44.63 58.9 46.06 60.39V54.15",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 21.78H37.97V29.93H46.07V21.84H38.04",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79 46.05V37.96H29.88V46.05H21.79Z",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.88 21.78H21.79V29.93H29.88V21.84H21.85",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.92,
    height: 67.91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweets);
export default __webpack_public_path__ + "static/media/sweets.66e1524f92e12a6052ef8f1305da85bd.svg";
export { ForwardRef as ReactComponent };